import { FormControl, Typography, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.fadedPurple.main}`,
    display: 'flex',
    flexDirection: 'row',
    padding: '10px 12px 10px',
  },
  logo: {
    borderRadius: theme.shape.borderRadius,
    flexShrink: 0,
    height: 35,
    marginRight: 6,
    objectFit: 'cover',
    width: 35,
  },
  label: {
    marginRight: theme.spacing(1),
  },
}))

const SupplierField = ({ label, supplier }) => {
  const classes = useStyles()

  return (
    <FormControl className={classes.root} margin="normal">
      <Typography
        className={classes.label}
        variant="body2"
        color="textSecondary"
      >
        {label}
      </Typography>
      {supplier.logo && (
        <img className={classes.logo} src={supplier.logo} alt={supplier.name} />
      )}
      <Typography>{supplier.name}</Typography>
    </FormControl>
  )
}

export default SupplierField
